import { FC } from "react";
import { ISuccessProps } from "../types";
import { Link } from "react-router-dom";
import QRCode from "react-qr-code";

interface SuccessProps {
  success: ISuccessProps;
}

export const Success: FC<SuccessProps> = ({ success }) => {
  return (
    <div className="flex flex-col items-center justify-center p-6">
      <div className="bg-white rounded-lg p-8 text-center max-w-md w-full space-y-4">
        <h1 className="text-2xl font-bold text-green-600 mb-4">
          Objednávka byla úspěšně přijata!
        </h1>

        <p className="text-lg">
          Číslo objednávky:{" "}
          <span className="font-semibold">{success.orderNumber}</span>
        </p>
        <p className="text-lg">
          Částka: <span className="font-semibold">{success.amount} CZK</span>
        </p>
        <p className="text-gray-600">
          Shrnutí bude zasláno na kontaktní email.
        </p>
        <p className="text-gray-600">
          QR-platba, můžete zaplatit i pomocí QR kodu v emailu, který jsme Vám
          právě zaslali
          <QRCode className="w-32 h-32 mx-auto mt-4" value={success.spd} />
        </p>

        {/* <div className="mb-6"></div> */}

        <p className="text-gray-600">Děkujeme za objednávku</p>
        <Link to="/homepage" className="text-blue-600 underline">
          {" "}
          Zpět na domovskou obrazovku
        </Link>
      </div>
    </div>
  );
};
